import { Component, OnInit } from '@angular/core';
import { PaymentManagementService, AllPayment } from '../payment-management.service';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as moment from 'moment';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ModalPaymentReportComponent } from '../modal-payment-report/modal-payment-report.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { of } from 'rxjs';
import { ExportToCsv } from 'export-to-csv';
import { DatePipe } from 'src/app/shared/pipe/date.pipe';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { ModalUploadSignatureComponent } from '../modal-upload-signature/modal-upload-signature.component';

@Component({
  selector: 'app-payment-management-goverment',
  templateUrl: './payment-management-goverment.component.html',
  styleUrls: ['./payment-management-goverment.component.scss']
})
export class PaymentManagementGovermentComponent implements OnInit {

  allPayment;
  search: string;
  isSearch: boolean = false;
  isLoading: boolean = false;

  data = [];
  listOfData: AllPayment[] = [];
  searchPayment: any = '';

  getReport;

  accountId: string = '';

  sortPaymentIDFn = (a: AllPayment, b: AllPayment) => a.PAYMENT_ID.localeCompare(b.PAYMENT_ID);
  sortDateFn = (a: AllPayment, b: AllPayment) => moment(a.PAYMENT_DATE).unix() - moment(b.PAYMENT_DATE).unix()
  typeFilterFn = (list: string[], item: AllPayment) => list.some(type => item.TYPE.indexOf(type) !== -1);
  statusFilterFn = (list: string[], item: AllPayment) => list.some(status => item.STATUS_PAYMENT.indexOf(status) !== -1);
  filterType = [
    { text: 'course', value: 'course' },
    { text: 'workshop', value: 'workshop' },
    { text: 'consult', value: 'consult' },
    { text: 'report', value: 'report' },
  ];
  filterStatus = [
    { text: 'สำเร็จ', value: 'success' },
    { text: 'รอการตรวจสอบ', value: 'waiting_confirm' },
    { text: 'ไม่สำเร็จ', value: 'reject' },
  ];

  constructor(
    public matDialog: MatDialog,
    private paymentManagementService: PaymentManagementService,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    this.accountId = new URL(location.href).searchParams.get('ACCOUNTING_ID');

    this.getAllPaymentManagement();
    this.gobalFunctionService.setTitle('รายการทางการเงิน');
  }

  getAllPaymentManagement() {
    this.isLoading = true;
    this.paymentManagementService.getAllPayment(this.accountId).pipe(
      map(res => {
        this.isLoading = false;
        // console.log(res.result);
        this.allPayment = res.result;
      })
    ).subscribe();
  }

  searching() {
    if (this.search !== '') {
      this.isSearch = true;
      this.listOfData = [];
      this.allPayment.filter(payment => {
        if (payment.PAYMENT_ID.toLowerCase().includes(this.search.toLowerCase()) || payment.USERNAME.toLowerCase().includes(this.search.toLowerCase())) {
          this.listOfData.push(payment)
        }
      });
    } else {
      this.isSearch = false;
      this.listOfData = null;
      this.getAllPaymentManagement();
    }
  }

  verify(pid) {
    window.open(`/payment-management/payment-management-goverment/payment-detail?paymentId=${pid}&ACCOUNTING_ID=${this.accountId}`, '_blank');
  }

  paymentReport() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '650px';
    dialogConfig.autoFocus = false;

    dialogConfig.data = {
      title: 'รายงานการเงิน',
      actionBtnText: 'ยืนยัน',
      cancleBtnText: 'ย้อนกลับ',
      isEdit: true,
    }

    const modal = this.matDialog.open(ModalPaymentReportComponent, dialogConfig);
    this.isLoading = true;
    return modal.afterClosed().pipe(
      switchMap(res => {
        if (res.status) {
          let start = new Date(res.value.startDate);
          start.setHours(start.getHours() + 7);

          let end = new Date(res.value.endDate);
          end.setHours(end.getHours() + 7);

          let bodyReport = {
            FROM_DATE: start,
            TO_DATE: end,
            ACCOUNTING_ID: this.accountId,
          }
          // console.log(bodyReport);

          return this.paymentManagementService.getPaymentReport(bodyReport).pipe(
            map(res => {
              // console.log(res);
              let report = []
              let ptype;
              let pstatus;
              let pTime;

              if (res.success) {
                this.getReport = res.result;

                if (!this.getReport.length) {

                  const dialogConfig2 = new MatDialogConfig();
                  dialogConfig2.disableClose = true;
                  dialogConfig2.id = 'modalConfirm';
                  dialogConfig2.width = '400px';
                  dialogConfig2.data = {
                    title: 'เลือกช่วงเวลา',
                    description: `<img src="../../../assets/close.png" width="100px;" class="img-center">
                                  <p class="title text-center">ไม่มีช่วงเวลาที่เลือก</p>
                                  <p class="text-center">กรุณาเลือกใหม่</p>`,
                    cancleBtnText: 'ยืนยัน',
                    customStyle: 'background-color: #58595B'
                  }

                  const modal = this.matDialog.open(ModalComponent, dialogConfig2);
                  this.isLoading = false;

                } else {
                  this.getReport.forEach(e => {
                    switch (e.PAYMENT_TYPE) {
                      case 'transfer': { ptype = 'โอน'; break; }
                      case 'free': { ptype = 'ฟรี'; break; }
                      case null: { ptype = ''; break; }
                      default: { ptype = e.PAYMENT_TYPE; break; }
                    }

                    switch (e.STATUS) {
                      case 'success': { pstatus = 'สำเร็จ'; break; }
                      case 'waiting_confirm': { pstatus = 'รอตรวจสอบ'; break; }
                      case 'reject': { pstatus = 'ไม่สำเร็จ'; break; }
                      case 'waiting_pay': { pstatus = 'รอจ่าย'; break; }
                    }

                    if (e.TRANFER_HR === null && e.TRANFER_MIN === null) {
                      pTime = ''
                    } else if (e.TRANFER_HR.length === 1 && e.TRANFER_MIN.length === 1) {
                      pTime = `0${e.TRANFER_HR}:0${e.TRANFER_MIN} น.`;
                    } else if (e.TRANFER_HR.length === 1 && e.TRANFER_MIN.length !== 1) {
                      pTime = `0${e.TRANFER_HR}:${e.TRANFER_MIN} น.`;
                    } else if (e.TRANFER_HR.length !== 1 && e.TRANFER_MIN.length === 1) {
                      pTime = `${e.TRANFER_HR}:0${e.TRANFER_MIN} น.`;
                    } else if (e.TRANFER_HR === '' && e.TRANFER_MIN === '') {
                      pTime = ``;
                    } else {
                      pTime = `${e.TRANFER_HR}:${e.TRANFER_MIN} น.`;
                    }

                    report.push({
                      CREATE_DATE: e.CREATE_DATE ? new DatePipe().transform(e.CREATE_DATE.toString(), 'full') : '-',
                      TRANFER_DATE: e.TRANFER_DATE ? new DatePipe().transform(e.TRANFER_DATE.toString(), 'full') : '-',
                      PAYMENT_TIME: pTime,
                      TYPE: e.TYPE,
                      PAYMENT_NAME: e.PAYMENT_NAME,
                      PRICE: e.PRICE ? e.PRICE : 0,
                      TRANFER_PRICE: e.REMARK_PRICE ? e.REMARK_PRICE : 0,
                      PAYMENT_TYPE: ptype,
                      NAME: e.NAME ? e.NAME : '',
                      ADDRESS: e.ADDRESS ? e.ADDRESS : '',
                      TEL: e.PAYMENT_PHONENUMBER ? e.PAYMENT_PHONENUMBER.toString() : '',
                      TAXID: e.TAX_NO ? e.TAX_NO.toString() : '',
                      USERNAME: e.USERNAME,
                      EMAIL: e.EMAIL,
                      APPROVE_NAME: e.APPROVE_NAME,
                      STATUS: pstatus,
                      URL: e.TRANFER_PIC,
                      PAYMENT_ID: e.PAYMENT_ID,
                      RECEIPT_ID: e.RECEIPT_ID ? e.RECEIPT_ID : '',
                      TRANS_ID: e.TRANS_ID ? e.TRANS_ID : '',
                      REMARK: e.REMARK ? e.REMARK : '',
                    })
                  });

                }
                // console.log(report);

                this.downloadReport(report, bodyReport);
              }
            })
          )
        }
        else {
          this.isLoading = false;
          return of(null);
        }
      }),
      catchError((err) => {
        alert(err);
        return of(null);
      })
    ).subscribe();
  }

  downloadReport(report, date): void {
    this.isLoading = false;
    // console.log(report);

    let fromDate = new DatePipe().transform(date.FROM_DATE.toString(), 'full');
    let toDate = new DatePipe().transform(date.TO_DATE.toString(), 'full');

    const options = {
      filename: `รายงานการเงินวันที่ ${fromDate} - ${toDate}`,
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: `รายงานการเงินวันที่ ${fromDate} - ${toDate}`,
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: false,
      headers: ['วันที่', 'วันที่ชำระ', 'เวลาที่ชำระ', 'หมวดหมู่', 'รายการ', 'ราคา', 'ราคาที่ชำระ', 'ช่องทางการชำระ', 'ชื่อ-สกุล', 'ที่อยู่', 'เบอร์โทรศัพท์', 'เลขที่ผู้เสียภาษี', 'ผู้ทำรายการ', 'อีเมลผู้ทำรายการ', 'ผู้ตรวจสอบ', 'สถานะ', 'หลักฐานการโอน', 'คำสั่งซื้อ', 'เลขที่ใบเสร็จรับเงิน', 'รหัสการทำรายการ', 'หมายเหตุ']
    };
    const csvExporter = new ExportToCsv(options);

    csvExporter.generateCsv(report);

  }

  uploadSignature() {
    const dialogConfig1 = new MatDialogConfig();

    dialogConfig1.disableClose = true;
    dialogConfig1.id = 'modalConfirm';
    dialogConfig1.width = '650px';
    dialogConfig1.autoFocus = false;

    dialogConfig1.data = {
      title: 'อัปโหลดลายเซ็น',
      actionBtnText: 'ยืนยัน',
      cancleBtnText: 'ย้อนกลับ',
      isEdit: true,
    }

    const modal = this.matDialog.open(ModalUploadSignatureComponent, dialogConfig1);
    this.isLoading = true;
    return modal.afterClosed().pipe(
      switchMap(res => {
        if (res.status) {
          // this.isLoading = false;
          // console.log(res);

          return this.paymentManagementService.updateSignature(res.value).pipe(
            map(res => {
              if (res.success) {

                this.isLoading = true
                const dialogConfig3 = new MatDialogConfig();
                dialogConfig3.disableClose = true;
                dialogConfig3.id = 'modalConfirm';
                dialogConfig3.width = '350px';
                dialogConfig3.data = {
                  title: 'อัปเดตลายเซ็นสำเร็จ',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">อัปเดตสำเร็จ`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }

                const modal = this.matDialog.open(ModalComponent, dialogConfig3);
                this.isLoading = false;
              } else {
                this.isLoading = false;
                return of(null);
              }

            })
          )
        }
        else {
          this.isLoading = false;
          return of(null);
        }
      }),
      catchError(() => {
        this.isLoading = false;
        alert('ไม่สามารถดำเนินการได้ในขณะนี้ กรุณาดำเนินการใหม่ภายหลัง');
        return of(null);
      })
    ).subscribe();
  }

}
